import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer({ onConsult }) {
  return (
    <footer className="bg-[#050505] border-t border-[#222] pt-20 pb-10" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6">
            <p className="font-mono-accent text-[#005EEA] text-xs mb-4">Ready?</p>
            <button
              onClick={onConsult}
              className="font-display text-white text-left text-[13vw] md:text-[6vw] leading-[0.85] hover:text-[#005EEA] transition-colors"
              data-testid="footer-cta"
            >
              Let's get<br />to work.
            </button>
          </div>
          <div className="md:col-span-3 md:col-start-9">
            <p className="font-mono-accent text-[10px] text-[#666] mb-5">Contact</p>
            <ul className="space-y-3 text-[#A0A0A0]">
              <li>
                <a href="mailto:getfitwithjeanclaude@gmail.com" className="flex items-center gap-3 hover:text-white transition-colors">
                  <Mail size={15} /> getfitwithjeanclaude@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+16475132225" className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-phone">
                  <Phone size={15} /> 647-513-2225
                </a>
              </li>
              <li>
                <a href="https://instagram.com/getfitwithjeanclaude" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-instagram">
                  <Instagram size={15} /> @getfitwithjeanclaude
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#222] pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-display text-white text-lg tracking-tight">
            GETFIT<span className="text-[#005EEA]">/</span>JEANCLAUDE
          </p>
          <div className="flex items-center gap-6">
            <span className="font-mono-accent text-[10px] text-[#555]">© {new Date().getFullYear()} All rights reserved</span>
            <a href="/privacy" className="font-mono-accent text-[10px] text-[#555] hover:text-[#005EEA] transition-colors" data-testid="privacy-link">
              Privacy
            </a>
            <a href="/login" className="font-mono-accent text-[10px] text-[#555] hover:text-[#005EEA] transition-colors" data-testid="admin-link">
              Coach Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
